$(document).ready(() => {
    RegisterFieldBinders($(document) as unknown as JQuery<HTMLElement>);
});

function RegisterFieldBinders($context: JQuery<HTMLElement>): void {

    $context.findInGrid('div[name="DetailsUser"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "User",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsRole"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "Role",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsPermission"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "Permission",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsWebsiteContent"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "WebsiteContent",
            getDetails: function (this: FieldsBinder, event: any) {
                const $editor = this.$parent.find('[name="WebsiteContentData"]');

                if ($editor.length) {
                    const summernoteEditor = ($editor as any).summernote();
                    const isHtmlMode = summernoteEditor.summernote('codeview.isActivated');

                    if (isHtmlMode) {
                        summernoteEditor.summernote('codeview.deactivate');
                    }
                }

                return this.getDefaultDetails(event);
            }
        });

        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsAllSqlQuery"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "AllSqlQuery",
        });
        fieldsBinder.bindSaveButtons();
    });
}